<div>
  <ng-template app-plugin-view #pluginContainer></ng-template>
</div>
